import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rules: {
    loading: false,
    error: null,
    data: null,
  },
  ruleDetail: {
    loading: false,
    error: null,
    data: null,
  },
  thresholds: {
    loading: false,
    error: null,
    data: null,
  },
  logs: {
    loading: false,
    error: null,
    data: null,
  },
  heatingSeasons: {
    loading: false,
    error: null,
    data: null,
  },
  heatingSeasonStatus: {
    loading: false,
    error: null,
    data: null,
  },
  createRule: {
    loading: false,
    error: null,
    data: null,
  },
  updateRule: {
    loading: false,
    error: null,
    data: null,
  },
  deleteRule: {
    loading: false,
    error: null,
    data: null,
  },
};

const tankNotificationRulesSlice = createSlice({
  name: "tankNotificationRules",
  initialState,
  reducers: {
    // Rules listing
    rulesStart: (state) => {
      state.rules.loading = true;
      state.rules.error = null;
    },
    rulesSuccess: (state, action) => {
      state.rules.loading = false;
      state.rules.data = action.payload;
      state.rules.error = null;
    },
    rulesFailure: (state, action) => {
      state.rules.loading = false;
      state.rules.error = action.payload;
    },

    // Rule detail
    ruleDetailStart: (state) => {
      state.ruleDetail.loading = true;
      state.ruleDetail.error = null;
    },
    ruleDetailSuccess: (state, action) => {
      state.ruleDetail.loading = false;
      state.ruleDetail.data = action.payload;
      state.ruleDetail.error = null;
    },
    ruleDetailFailure: (state, action) => {
      state.ruleDetail.loading = false;
      state.ruleDetail.error = action.payload;
    },
    ruleDetailReset: (state) => {
      state.ruleDetail = initialState.ruleDetail;
    },

    // Thresholds (for widget)
    thresholdsStart: (state) => {
      state.thresholds.loading = true;
      state.thresholds.error = null;
    },
    thresholdsSuccess: (state, action) => {
      state.thresholds.loading = false;
      state.thresholds.data = action.payload;
      state.thresholds.error = null;
    },
    thresholdsFailure: (state, action) => {
      state.thresholds.loading = false;
      state.thresholds.error = action.payload;
    },

    // Notification logs
    logsStart: (state) => {
      state.logs.loading = true;
      state.logs.error = null;
    },
    logsSuccess: (state, action) => {
      state.logs.loading = false;
      state.logs.data = action.payload;
      state.logs.error = null;
    },
    logsFailure: (state, action) => {
      state.logs.loading = false;
      state.logs.error = action.payload;
    },

    // Heating seasons
    heatingSeasonsStart: (state) => {
      state.heatingSeasons.loading = true;
      state.heatingSeasons.error = null;
    },
    heatingSeasonsSuccess: (state, action) => {
      state.heatingSeasons.loading = false;
      state.heatingSeasons.data = action.payload;
      state.heatingSeasons.error = null;
    },
    heatingSeasonsFailure: (state, action) => {
      state.heatingSeasons.loading = false;
      state.heatingSeasons.error = action.payload;
    },

    // Heating season status
    heatingSeasonStatusStart: (state) => {
      state.heatingSeasonStatus.loading = true;
      state.heatingSeasonStatus.error = null;
    },
    heatingSeasonStatusSuccess: (state, action) => {
      state.heatingSeasonStatus.loading = false;
      state.heatingSeasonStatus.data = action.payload;
      state.heatingSeasonStatus.error = null;
    },
    heatingSeasonStatusFailure: (state, action) => {
      state.heatingSeasonStatus.loading = false;
      state.heatingSeasonStatus.error = action.payload;
    },

    // Create rule
    createRuleStart: (state) => {
      state.createRule.loading = true;
      state.createRule.error = null;
      state.createRule.data = null;
    },
    createRuleSuccess: (state, action) => {
      state.createRule.loading = false;
      state.createRule.data = action.payload;
      state.createRule.error = null;
    },
    createRuleFailure: (state, action) => {
      state.createRule.loading = false;
      state.createRule.error = action.payload;
    },
    createRuleReset: (state) => {
      state.createRule = initialState.createRule;
    },

    // Update rule
    updateRuleStart: (state) => {
      state.updateRule.loading = true;
      state.updateRule.error = null;
      state.updateRule.data = null;
    },
    updateRuleSuccess: (state, action) => {
      state.updateRule.loading = false;
      state.updateRule.data = action.payload;
      state.updateRule.error = null;
    },
    updateRuleFailure: (state, action) => {
      state.updateRule.loading = false;
      state.updateRule.error = action.payload;
    },
    updateRuleReset: (state) => {
      state.updateRule = initialState.updateRule;
    },

    // Delete rule
    deleteRuleStart: (state) => {
      state.deleteRule.loading = true;
      state.deleteRule.error = null;
      state.deleteRule.data = null;
    },
    deleteRuleSuccess: (state, action) => {
      state.deleteRule.loading = false;
      state.deleteRule.data = action.payload;
      state.deleteRule.error = null;
    },
    deleteRuleFailure: (state, action) => {
      state.deleteRule.loading = false;
      state.deleteRule.error = action.payload;
    },
    deleteRuleReset: (state) => {
      state.deleteRule = initialState.deleteRule;
    },
  },
});

export const {
  rulesStart,
  rulesSuccess,
  rulesFailure,
  ruleDetailStart,
  ruleDetailSuccess,
  ruleDetailFailure,
  ruleDetailReset,
  thresholdsStart,
  thresholdsSuccess,
  thresholdsFailure,
  logsStart,
  logsSuccess,
  logsFailure,
  heatingSeasonsStart,
  heatingSeasonsSuccess,
  heatingSeasonsFailure,
  heatingSeasonStatusStart,
  heatingSeasonStatusSuccess,
  heatingSeasonStatusFailure,
  createRuleStart,
  createRuleSuccess,
  createRuleFailure,
  createRuleReset,
  updateRuleStart,
  updateRuleSuccess,
  updateRuleFailure,
  updateRuleReset,
  deleteRuleStart,
  deleteRuleSuccess,
  deleteRuleFailure,
  deleteRuleReset,
} = tankNotificationRulesSlice.actions;

export default tankNotificationRulesSlice.reducer;
